/*
登录接口
*/ 
import { axios } from '@/utils/http'

// 登录
export const login = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true
}, '/login')

//手机免密登录
export const phoneLogin = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  data: {
    ...params
  },
  noToast: true
}, '/phoneLogin')


// 注册
export const register = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true
}, '/register')

// 发送短信验证码
export const sendSms = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
}, '/sms?'+params)


// 发送邮箱验证码
export const sendEmailSms = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  noToast: true,
}, '/emailCode?'+params)

//退出登录
export const loginOut = (params) => axios({
  method: 'POST',
  payHeader: true ,
  contentType: 'application/json',
}, '/logout')

//忘记密码
export const forgotPassword = (params) => axios({
  method: 'POST',
  contentType: 'urlencoded',
  noToast: true,
}, '/forgotPassword?'+params)

//第三方微信登录
export const getRender = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
}, '/render')

//第三方登录绑定手机号
export const thirdRegister = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
}, '/thirdRegister')

//生成统一认证地址
export const getRenderUnify = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
}, '/render/unify')

//获取地区信息
export const getAreaInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
}, '/commonInfo/getAreaInfo?pid='+params)

//根据id获取对应地点信息
export const getAreaDotInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
}, '/commonInfo/getAreaInfoById?id='+params)

//获取领域业务信息
export const getBusinessTags = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
}, '/commonInfo/getBusinessTags?pid='+params)

//获取地区信息
export const getAreaById = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
}, '/commonInfo/getAreaInfoById?id='+params)

//获取领域业务信息
export const getBusinessById = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  noToast: true,
}, '/commonInfo/getBusinessTagsById?id='+params)


// WEBPACK FOOTER //
// ./src/api/login/login.js